<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewDataLocal"
    @vs-close="closeForm">
    <form @submit.prevent>
      <!--<vs-select placeholder="- Select -" v-model="fleetGroup" label="Fleet Group" class="w-full mb-6" :disabled="fleet_array.length===0 ">-->
      <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in fleet_array" />-->
      <!--</vs-select>-->
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Fleet Group</label>
        <v-select
          @input="(x) => (fleetGroup = x.value)"
          :clearable="false"
          :value="getSelectValue(fleetGroup, fleet_array)"
          :reduce="(text) => text.value"
          label="text"
          :options="fleet_array" />
      </div>
      <vs-row vs-w="12">
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12">
          <vx-card>
            <template slot="no-body">
              <vs-row vs-w="12" style="border-bottom: 1px solid #ded8d8">
                <vs-col
                  style="padding: 5px"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="5"
                  vs-sm="5"
                  vs-xs="12">
                  <vs-chip>
                    <vs-avatar icon-pack="feather" icon="icon-bell" />
                    <span>Master</span>
                  </vs-chip>
                </vs-col>
                <vs-col
                  style="padding: 7px 0 0 0"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="7"
                  vs-sm="7"
                  vs-xs="12">
                  <vs-input
                    size="small"
                    class="inputx w-full"
                    placeholder="Filter.."
                    v-model="searchA" />
                  <!--<input type="text" v-model="searchA" class="mt-1 mb-1 vs-inputx vs-input&#45;&#45;input normal" placeholder="Search..">-->
                </vs-col>
              </vs-row>
              <vs-list style="height: calc(100vh - 400px); overflow: auto">
                <!--<draggable :list="listVehicle" group="people" class="p-2 cursor-move">-->
                <vs-list-item
                  v-for="(listItem, index) in filteredListA()"
                  :key="index"
                  :title="listItem.alert_name"
                  :subtitle="listItem.alert_code">
                  <!--<vs-avatar slot="avatar" :text="listItem.name" @click="addThis(listItem)"/>-->
                  <template slot="avatar">
                    <span class="icon-container">
                      <feather-icon
                        color="green"
                        icon="ChevronRightIcon"
                        svgClasses="w-4 h-4"></feather-icon>
                    </span>
                  </template>
                  <div
                    class="vs-list--slot cursor"
                    style="color: green"
                    @click="addThis(listItem)">
                    <span>
                      <feather-icon
                        color="green"
                        icon="PlusIcon"
                        svgClasses="w-8 h-8"></feather-icon>
                    </span>
                  </div>
                </vs-list-item>
                <!--</draggable>-->
              </vs-list>
            </template>
          </vx-card>
        </vs-col>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12">
          <vx-card>
            <template slot="no-body">
              <vs-row vs-w="12" style="border-bottom: 1px solid #ded8d8">
                <vs-col
                  style="padding: 5px"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="5"
                  vs-sm="5"
                  vs-xs="12">
                  <vs-chip>
                    <vs-avatar icon-pack="feather" icon="icon-bell" />
                    <span>Paired</span>
                  </vs-chip>
                </vs-col>
                <vs-col
                  style="padding: 7px 0 0 0"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="7"
                  vs-sm="7"
                  vs-xs="12">
                  <vs-input
                    size="small"
                    class="inputx w-full"
                    placeholder="Filter.."
                    v-model="searchB" />
                  <!--<input  type="text" v-model="searchB" class="mt-1 mb-1 vs-inputx vs-input&#45;&#45;input normal" placeholder="Search..">-->
                </vs-col>
              </vs-row>

              <!--<input type="text" v-model="searchB" class="vs-inputx vs-input&#45;&#45;input normal custom-search" placeholder="Search..">-->
              <vs-list style="height: calc(100vh - 400px); overflow: auto">
                <!--<draggable :list="listPaired" group="people" class="p-2 cursor-move">-->
                <vs-list-item
                  v-for="(listItem, index) in filteredListB()"
                  :key="index"
                  :title="listItem.alert_name"
                  :subtitle="listItem.alert_code">
                  <!--<vs-avatar @click="removeThis(listItem)" slot="avatar" text="listItem.name" />-->
                  <template slot="avatar">
                    <span class="icon-container">
                      <feather-icon
                        color="green"
                        icon="ChevronRightIcon"
                        svgClasses="w-4 h-4"></feather-icon>
                    </span>
                  </template>
                  <div
                    class="vs-list--slot cursor"
                    style="color: red"
                    @click="removeThis(listItem)">
                    <span>
                      <feather-icon
                        color="green"
                        icon="XIcon"
                        svgClasses="w-8 h-8"></feather-icon>
                    </span>
                  </div>
                </vs-list-item>
                <!--</draggable>-->
              </vs-list>
            </template>
          </vx-card>
        </vs-col>
      </vs-row>
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
          @click="submitForm"
          v-if="!editMode"
          :disabled="fleetGroup == '' || listPaired.length == 0"
          >Submit
        </vs-button>
        <vs-button
          class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
          @click="updateForm"
          v-if="editMode"
          :disabled="fleetGroup == '' || listPaired.length == 0"
          >Update
        </vs-button>
        <!--<vs-button color="danger" class="mr-3 mb-2 btn-load-3 vs-con-loading__container" @click="deleteData" v-if="editMode">Delete</vs-button>-->
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    alertData: Array,
    fleetGroupData: Array,
    all_fleet: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  watch: {
    listPaired(val) {
      //
      //
    },
    addNewDataLocal() {
      if (this.addNewData && !this.editMode) {
        this.calculateFleet()
        this.listPaired = []
        this.alert_array = this.alertData
      }
      if (this.addNewData && this.editMode) {
        this.calculateFleetEdit(this.s_alert)
        this.fleetGroup = this.dataEdit.id
        this.calculateFleetEdit(this.s_alert)
        //
      } else {
        this.clearFields()
      }
    },
    editMode(val) {},
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        // this.clearFields();
        if (this.alertData.length > 0 && this.addNewData) {
          //
          // this.alert_array = [];
          // let tmp=[];
          // this.alertData.forEach(x=>{
          //     tmp.push({
          //         value:x.id,
          //         text:x.alert_name
          //     })
          // });
        }
        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      listPaired: [],
      s_alert: '',
      searchA: '',
      searchB: '',
      fleetGroup: '',
    }
  },
  methods: {
    filteredListA() {
      if (this.searchA.length > 0) {
        return this.alert_array.filter((post) => {
          return post.alert_name
            .toLowerCase()
            .includes(this.searchA.toLowerCase())
        })
      } else {
        //
        return this.alert_array
      }
    },
    filteredListB() {
      if (this.searchB.length > 0) {
        return this.listPaired.filter((post) => {
          return post.alert_name
            .toLowerCase()
            .includes(this.searchB.toLowerCase())
        })
      } else {
        return this.listPaired
      }
    },
    removeA(arr, key, val) {
      return arr.filter(function (obj) {
        return obj[key] !== val
      })
    },
    addThis(val) {
      //
      this.alert_array = this.removeA(this.alert_array, 'id', val.id)

      this.listPaired.push(val)
    },
    removeThis(val) {
      //
      this.listPaired = this.removeA(this.listPaired, 'id', val.id)
      let tmp = this.alertData.filter((x) => {
        return x.id == val.id
      })
      if (tmp.length > 0) {
        this.alert_array.push(val)
      }
    },
    calculateFleetEdit(val) {
      this.fleet_array = []
      //
      this.fleetGroupData.forEach((x) => {
        let cek = this.allData.filter((a) => {
          return x.fleet_group_code === a.fleet_group_code
        })
        //
        if (
          cek.length === 0 ||
          x.fleet_group_code == this.dataEdit.fleet_group_code
        ) {
          this.fleet_array.push({
            value: x.id,
            text: x.fleet_group_name,
          })
        }
      })
      this.alert_array = []
      this.listPaired = []
      this.dataEdit.alert_mapping.forEach((x) => {
        this.listPaired.push(x.alert)
      })
      let tmp = []
      //
      this.alertData.forEach((x) => {
        let cek = this.dataEdit.alert_mapping.filter((a) => {
          return x.id == a.alert_id
        })
        if (cek.length == 0) {
          tmp.push(x)
        }
      })
      this.alert_array = tmp
      //
    },
    calculateFleet(val) {
      this.fleet_array = []
      this.fleetGroupData.forEach((x) => {
        //
        let cek = this.allData.filter((a) => {
          return x.fleet_group_code === a.fleet_group_code
        })

        if (cek.length === 0) {
          this.fleet_array.push({
            value: x.id,
            text: x.fleet_group_name,
          })
        }
      })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.listPaired = []
      this.fleetGroup = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1')
      let alert = []
      this.listPaired.forEach((x) => {
        alert.push(x.id)
      })
      let dataForm = {
        data_alert: alert,
        fleet_group_id: this.fleetGroup,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.postAlertMapping(dataForm)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-1')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.loadingBtnStop('btn-load-1')
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-load-1')
          //
          this.$toast.error(err.message)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteAlert(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let alert = []
      this.listPaired.forEach((x) => {
        alert.push(x.id)
      })
      let dataForm = {
        data_alert: alert,
        fleet_group_id: this.fleetGroup,
        created_by: this.$dataLocal.UserData().name,
      }
      //
      //
      REPO.updateAlertMapping(dataForm, this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          this.$toast.error(err.message)
        })
    },
  },
}
</script>
<style scoped>
.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}
</style>
